import AppRecord from './AppRecord.js'

class IsinMapping extends AppRecord {

}
export default IsinMapping
